var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('YourDetails',{attrs:{"step":_vm.step},on:{"clicked":_vm.updateStep,"goToStep":_vm.customStep,"fullName":_vm.setFullName,"oldAddress":_vm.setOldAddress,"newAddress":_vm.setNewAddress,"cc":_vm.setCC,"dob":_vm.setDob}})}
var staticRenderFns = []

export { render, staticRenderFns }